import "./../styles.scss";

import { EditOutlined, LoadingOutlined } from "@ant-design/icons";
import { Checkbox, Dropdown, Menu, notification, Pagination, Select, Spin, Tooltip } from "antd";
import MultiInputField from "components/common/MultiInputField";
import MultiSelectWithRepeat from "components/common/MultiSelectWithRepeat";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMemo } from "react";
import Modal from "react-modal";
import { useOutletContext, useSearchParams } from "react-router-dom";
import Select2 from "react-select";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import {
  awsRegions,
  bitRateModes,
  mediaLiveInput,
  mediaLiveTemplateOption,
  mediaLiveTemplateRegions,
  mediaStaticInput,
  streamingType,
} from "../../../config";
import {
  backupInputTypes,
  ENTITY_TYPE,
  mediaLiveTemplateOptions,
  multiAudioOptions,
  PROGRAM_DATE_TIME,
  pushStreamInputTypes,
  reservedChannelInputType,
} from "../../../constants/phase";
import { addTemplateValidation } from "../../../utils/validations";
import RunningStreams from "../../Configuration/partials/RunningStreams";
import EditMediaLiveTemplate from "./EditMediaLiveTemplate";
const { Option } = Select;
const MediaLiveTemplate = ({ ...props }) => {
  const {
    loder,
    setLoder,
    notify,
    setNotify,
    getStorage,
    storageDetail,
    setStorageDetail,
    addMediaTemplate,
    getMediaTemplate,
    deleteMediaTemplate,
    editMediaTemplate,
    listReservedChannel,
    usersList,
    getRunningStreamTemplates,
    entityId,
    getOrgDetails,
    fetchTemplateConfig,
  } = props;
  const [multiAudioOption, setMultiAudioOption] = useState("");

  const { user, entityType } = useOutletContext();
  const [templates, setTemplates] = useState();
  const [template, setTemplate] = useState();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [delLoder, setDelLoder] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [reservedChannel, setReservedChannel] = useState([]);
  const [filteredReservedChannels, setFilteredReservedChannels] = useState([]);
  const [selectedChannel, setSelectedChannel] = useState([]);
  const [initialState, setInitialState] = useState({
    templateName: "",
    height: "",
    width: "",
    bitrate: "",
    fps: "",
    type: "",
    region: undefined,
    inputType: "",
    streamingType: "live_to_vod",
    mediaLiveRegion: undefined,
    mediaLiveStorageId: "",
    isMultiAudio: false,
    fillMultiAudioWithStream: true,
    passwordEnabled: false,
    iso: "",
    pid: [],
    track: [],
    languages: [],
    fpsMode: "",
    reservedChannels: [],
    multiAudioOption: "iso",
    fileType: "",
    bitRateMode: "CBR",
    programDateTime: PROGRAM_DATE_TIME.INCLUDE,
    streamSelectionBitrate: 0,
    streamSelectionBitrateEnable: false,
    isBackup: false,
  });
  const [show, setShow] = useState(false);
  const [totalCounts, setTotalCount] = useState(0);
  const [load, setLoad] = useState(false);
  const [inputType, setInputType] = useState("");
  const [selectedAudioOptions, setSelectedAudioOptions] = useState([]);
  const [selectedPids, setSelectedPids] = useState([]);
  const [selectedTracks, setSelectedTracks] = useState([]);
  const [templateConfigData, setTemplateConfigData] = useState({});
  const [minBitrateError, setMinBitrateError] = useState(false);
  const [bitRate, setBitRate] = useState("");
  const antIcon = <LoadingOutlined style={{ fontSize: 30, align: "center" }} spin />;
  const [selectedTemplateType, setSelectedTemplateType] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const updatedSearchParams = useMemo(() => new URLSearchParams(searchParams.toString()), [searchParams]);

  const handlePageChange = (current) => {
    setActivePage(current);
  };

  useEffect(() => {
    getMediaTemplates();
  }, [selectedTemplateType, activePage]);
  const getMediaTemplates = async () => {
    setLoad(true);
    try {
      const { value } = await getMediaTemplate({
        entityId: entityId,
        pageNo: activePage,
        limit: 20,
        outputTemplateType: selectedTemplateType?.value,
      });
      if (value.success) {
        setTemplates(value.data || []);
        setTotalCount(value.totalTemplates);
      } else notification["error"]({ message: value.message });
    } catch (error) {
      notification["error"]({ message: "Something went wrong" });
    }
    setLoad(false);
  };
  const getTemplateConfig = async () => {
    const response = await fetchTemplateConfig();
    if (response.value.status) {
      setTemplateConfigData(response.value.data.videoTemplateConfiguration);
    } else {
      notification["error"]({ message: "Something went wrong" });
    }
  };
  useEffect(() => {
    getTemplateConfig();
  }, []);
  useEffect(() => {
    if (parseInt(bitRate) < parseInt(templateConfigData?.minBitrate)) {
      setMinBitrateError(true);
    } else {
      setMinBitrateError(false);
    }
  }, [bitRate]);
  useEffect(() => {
    getStorageDetails();
    getReservedChannel();
  }, [activePage]);
  useEffect(() => {
    setFilteredReservedChannels(
      reservedChannel
        .filter(
          (channel) => channel.inputType !== undefined && channel.inputType === inputType && !channel?.deleteRequested,
        )
        .map((channel) => {
          return { label: channel?.channelName, value: channel?._id };
        }),
    );
  }, [inputType]);

  const getReservedChannel = async () => {
    //fetch list of all reservrewd channel assigned to user
    const { value } = await listReservedChannel({
      userId: user?.userId,
      entityId,
      limit: 500,
    });
    setReservedChannel(value?.data || []);
  };

  const getStorageDetails = async () => {
    const { value } = await getStorage({
      entityId: entityId,
      type: "sports_keymoments",
    });
    const mediaStorageDetails = value.storages.filter((storage) => storage.storage_type === "medialive");
    setStorageDetail(mediaStorageDetails);
  };

  const handleSubmit = async (values) => {
    setLoder(true);

    const payload = {
      entityId: entityId,
      templateName: values?.templateName,
      fps: values?.fpsMode === "static" ? values?.fps : "INITIALIZE_FROM_SOURCE",
      bitRateMode: values?.bitRateMode,
      bitrate: values?.bitrate,
      outputRegion: values?.region,
      outputTemplateType: values?.type,
      height: values?.height,
      width: values?.width,
      mediaLiveStorageId: ["medialive", "direct", "reserved_channel"].includes(values?.type)
        ? values?.mediaLiveStorageId
        : undefined,
      input_type: values?.type == "medialive" || values?.type == "reserved_channel" ? values?.inputType : undefined,
      streaming_mode: values?.inputType === "URL_PULL" ? values.streamingType : "live_to_vod",
      region: values?.type == "medialive" ? values?.mediaLiveRegion : undefined,
      reservedChannels: values?.type === "reserved_channel" ? values?.reservedChannels : undefined,
      isSRTPassword: values?.type === "medialive" ? values?.passwordEnabled : undefined,
      isMultiAudio: values?.isMultiAudio,
      file_type: values?.fileType,
      program_date_time: values?.programDateTime,
      streamSelectionBitrateEnable: values?.streamSelectionBitrateEnable,
      streamSelectionBitrate: values?.streamSelectionBitrate,
      isBackup: values?.isBackup,
    };

    if (values?.isMultiAudio) {
      payload.fillMultiAudioWithStream = values?.fillMultiAudioWithStream;
      payload.multi_audio_type = multiAudioOption;
      payload.multi_audios =
        multiAudioOption === "iso"
          ? selectedAudioOptions.map((audio) => audio.value)
          : multiAudioOption === "track"
            ? values?.track
            : values?.pid;
    }

    const { value } = await addMediaTemplate(payload);
    if (value.success) {
      notification["success"]({ message: value.message });
      setNotify(false);
      closeModal();
    } else if (
      value.success == false &&
      value.message == `Template already exists with name: ${values?.templateName}`
    ) {
      setNotify(true);
    } else {
      notification["error"]({ message: value.message });
      closeModal();
    }
    getMediaTemplates();
    setLoder(false);
  };

  const handlChange = (setFieldValue, e) => {
    if (e?.target?.name) {
      setFieldValue(e.target.name, e.target.value);
    }
    setNotify(false);
  };

  const handleShowRunningStreams = (value) => {
    setShow(value);
    getMediaTemplates();
  };
  const EditOpen = () => {
    setEditOpen(true);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setSelectedChannel([]);
    setIsOpen(false);
    setNotify(false);
    setMultiAudioOption("");
    setSelectedAudioOptions([]);
    setSelectedPids([]);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };

  const delOpen = () => {
    setDeleteModalOpen(true);
  };

  const deleteTemplate = async () => {
    setDelLoder(true);
    const { value } = await deleteMediaTemplate(template?._id);
    if (value?.success) {
      delclose();
      notification["success"]({ message: value.message });
    } else {
      delclose();
      notification["error"]({ message: value.message });
    }
    getMediaTemplates();
    setDelLoder(false);
  };

  const handleSelectChange = (value) => {
    setMultiAudioOption(value);
    setSelectedTracks([]);
  };

  const handleFPSModeChange = (value, values, setFieldValue) => {
    setFieldValue("fpsMode", value);
    if (value === "dynamic" && values.fps === "") {
      setFieldValue("fps", 24);
    }
  };
  const filterInputTypes = (option, templateType) => {
    return (
      (templateType === "medialive" && !["RTMP_PUSH", "SRT_PUSH"].includes(option.value)) ||
      (templateType === "reserved_channel" && [...reservedChannelInputType].includes(option.value)) ||
      templateType === "direct"
    );
  };

  useEffect(() => {
    if (updatedSearchParams.get("selectedTemplateType")) {
      setSelectedTemplateType(JSON.parse(updatedSearchParams.get("selectedTemplateType")));
    }
  }, [searchParams, updatedSearchParams]);

  const handleTemplateChange = (e) => {
    setSelectedTemplateType(e);
    updatedSearchParams.set("selectedTemplateType", JSON.stringify(e));
    setSearchParams(updatedSearchParams);
  };
  const handleReservedChannels = (setFieldValue, value, values) => {
    if (!value || value.length === 0) {
      setFieldValue("reservedChannels", []);
      return;
    }

    if (pushStreamInputTypes.includes(values?.inputType)) {
      // Check if any selected item has `is_domain` set to true
      if (values?.reservedChannels?.length > 0) {
        notification["error"]({
          message: "In case of RTMP/SRT PUSH, only a single reserved channel can be added to one template.",
        });
        return; // Prevent adding another channel
      }

      // If selection is compatible, proceed with setting the filtered value
      setFieldValue("reservedChannels", value);
    } else {
      // For non-RTMP input types, set the value directly
      setFieldValue("reservedChannels", value);
    }
  };

  return (
    <>
      <DeleteModal
        setDeleteModalOpen={setDeleteModalOpen}
        modalIsOpen={delmodalOpen}
        loder={delLoder}
        deleteComanModel={deleteTemplate}
        header="Delete"
        content="Are you sure you want to delete?"
      />
      <EditMediaLiveTemplate
        editOpen={editOpen}
        template={template}
        setEditOpen={setEditOpen}
        loder={loder}
        setLoder={setLoder}
        user={user}
        notify={notify}
        setNotify={setNotify}
        reservedChannel={reservedChannel}
        storageDetail={storageDetail}
        setStorageDetail={setStorageDetail}
        getMediaTemplates={getMediaTemplates}
        editMediaTemplate={editMediaTemplate}
        entityId={entityId}
        templateConfigData={templateConfigData}
      />

      {/* Add New Template Modal */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        ariaHideApp={false}
        className="modal-dialog react-modal-dialog-xm modal-dialog-centered"
      >
        <div className="modal-content">
          <AccessControl code="output_video_template" page="configuration">
            <div className="react-modal-header">
              <h5 className="react-modal-title">Add Video Template</h5>
              <button type="button" onClick={closeModal} className="btn btn__default">
                <CloseModal />
              </button>
            </div>
          </AccessControl>
          <Formik initialValues={initialState} validationSchema={addTemplateValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Template Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="templateName"
                        type="text"
                        placeholder="Enter Name"
                        value={values.templateName}
                        onChange={(e) => handlChange(setFieldValue, e)}
                      />
                      {notify && <div className="invalid-feedback">Template name already exists!</div>}
                      {touched.templateName && errors.templateName && (
                        <div className="invalid-feedback">{errors.templateName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Height <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="height" type="text" placeholder="Enter Height" />
                      {touched.height && errors.height && <div className="invalid-feedback">{errors.height}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Width <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="width" type="text" placeholder="Enter Width" />
                      {touched.width && errors.width && <div className="invalid-feedback">{errors.width}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Bit Rate Mode <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        optionFilterProp="children"
                        name="bitRateMode"
                        component={Select}
                        options={bitRateModes}
                        onChange={(value) => setFieldValue("bitRateMode", value)}
                        value={values?.bitRateMode}
                        defaultValue={values?.bitRateMode}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Bitrate <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="bitrate"
                        type="text"
                        value={values?.bitrate}
                        onChange={(event) => {
                          setFieldValue("bitrate", event.target.value);
                          setBitRate(event.target.value);
                        }}
                        placeholder="Enter Bitrate"
                      />
                      {touched.bitrate && errors.bitrate && <div className="invalid-feedback">{errors.bitrate}</div>}
                      {touched.bitrate && minBitrateError && (
                        <div className="invalid-feedback">{`Minimum bitrate should be ${templateConfigData?.minBitrate}`}</div>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        FPS Mode <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="fpsMode"
                        onChange={(value) => handleFPSModeChange(value, values, setFieldValue)}
                        component={Select}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={"Select FPS Mode"}
                      >
                        <Option value="static">Static</Option>
                        <Option value="dynamic">Dynamic</Option>
                      </Field>
                      {touched.fpsMode && errors.fpsMode && <div className="invalid-feedback">{errors.fpsMode}</div>}
                    </div>
                    {values.fpsMode === "static" ? (
                      <div className="form-group">
                        <label className="form-label">
                          FPS <span className="required">*</span>
                        </label>
                        <Field className="form-control" name="fps" type="text" placeholder="Enter FPS" />
                        {touched.fps && errors.fps && <div className="invalid-feedback">{errors.fps}</div>}
                      </div>
                    ) : null}
                    <div className="form-group">
                      <label className="form-label">
                        Output Media Type <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="type"
                        showSearch
                        onChange={(value) => {
                          setFieldValue("type", value);
                          setFieldValue("reservedChannels", []);
                          setFieldValue("inputType", "");
                          setFieldValue("streamingType", "live_to_vod");
                          setInputType("");
                          setFieldValue("fileType", "");
                        }}
                        component={Select}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={"Select Type"}
                      >
                        {mediaLiveTemplateOption.length &&
                          mediaLiveTemplateOption.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data.value}>
                                  {data.label}
                                </Option>
                              </>
                            );
                          })}
                      </Field>
                      {touched.type && errors.type && <div className="invalid-feedback">{errors.type}</div>}
                    </div>
                    {values?.type === "medialive" && (
                      <div className="form-group">
                        <label className="form-label">
                          File Type <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          name="fileTYpe"
                          onChange={(value) => {
                            setFieldValue("fileType", value);
                            setFieldValue("inputType", "");
                            if (value === "static") {
                              setFieldValue("mediaLiveRegion", "ap-south-1");
                              setFieldValue("region", "asia");
                              setFieldValue("isMultiAudio", false);
                            }
                          }}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          defaultValue={"Select File Type Option"}
                        >
                          <Option value="static">Static</Option>
                          <Option value="live">Live</Option>
                        </Field>
                        {touched.fileType && errors.fileType && (
                          <div className="invalid-feedback">{errors.fileType}</div>
                        )}
                      </div>
                    )}
                    {((values?.type === "medialive" && values?.fileType !== "") ||
                      values?.type === "reserved_channel") && (
                      <div className="form-group">
                        <label className="form-label">
                          Input Type <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          name="inputType"
                          showSearch
                          value={values?.inputType || "Select Input Type"}
                          onChange={(value) => {
                            setInputType(value);
                            setFieldValue("inputType", value);
                            setFieldValue("streamingType", "live_to_vod");
                            setFieldValue("reservedChannels", []);
                            setFieldValue("streamSelectionBitrateEnable", false);
                            setFieldValue("streamSelectionBitrate", 0);
                            setFieldValue("isBackup", false);
                          }}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                        >
                          {values?.fileType === "static"
                            ? mediaStaticInput.map((data, index) => {
                                return (
                                  <Option key={index} value={data.value}>
                                    {data.label}
                                  </Option>
                                );
                              })
                            : mediaLiveInput.map((data, index) => {
                                return filterInputTypes(data, values?.type) ? (
                                  <Option key={index} value={data.value}>
                                    {data.label}
                                  </Option>
                                ) : (
                                  <></>
                                );
                              })}
                        </Field>
                        {touched.inputType && errors.inputType && (
                          <div className="invalid-feedback">{errors.inputType}</div>
                        )}
                      </div>
                    )}
                    {values.inputType === "URL_PULL" && (
                      <div className="form-group">
                        <label className="form-label">
                          Streaming Type <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          optionFilterProp="children"
                          name="streamingType"
                          component={Select}
                          options={streamingType}
                          onChange={(value) => setFieldValue("streamingType", value)}
                          value={values?.streamingType}
                          defaultValue={values?.streamingType}
                        />
                      </div>
                    )}
                    {values.inputType === "URL_PULL" &&
                    (values.fileType === "live" || values.type === "reserved_channel") ? (
                      <>
                        <div className="form-group mb-1">
                          <Field
                            component={Checkbox}
                            onChange={(e) => {
                              setFieldValue("streamSelectionBitrateEnable", e.target.checked);
                              setFieldValue("streamSelectionBitrate", 0);
                            }}
                            value={values?.streamSelectionBitrateEnable}
                            name="streamSelectionBitrateEnable"
                            checked={values?.streamSelectionBitrateEnable}
                            className="me-2"
                          />
                          <label className="form-label mr-1">Stream Selection from bitrate</label>
                        </div>
                        {values.streamSelectionBitrateEnable && (
                          <div className="form-group ">
                            <Field
                              className="form-control"
                              name="streamSelectionBitrate"
                              type="number"
                              placeholder="Enter Bitrate"
                            />
                            {touched.streamSelectionBitrate && errors.streamSelectionBitrate && (
                              <div className="invalid-feedback">{errors.streamSelectionBitrate}</div>
                            )}
                          </div>
                        )}
                      </>
                    ) : (
                      <></>
                    )}
                    {values?.type === "reserved_channel" && backupInputTypes.includes(values.inputType) && (
                      <div className="form-group mb-1">
                        <Field
                          component={Checkbox}
                          onChange={(e) => {
                            setFieldValue("isBackup", e.target.checked);
                          }}
                          value={values?.isBackup}
                          name="isBackup"
                          checked={values?.isBackup}
                          className="me-2"
                        />
                        <label className="form-label mr-1">Stream Backup</label>
                      </div>
                    )}

                    {values?.type === "reserved_channel" && (
                      <div className="form-group">
                        <label className="form-label">
                          Reserved Channel <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          optionFilterProp="children"
                          name="reservedChannels"
                          showSearch
                          mode="multiple"
                          component={Select}
                          placeholder="Select channels"
                          value={values?.reservedChannels}
                          onChange={(value) => handleReservedChannels(setFieldValue, value, values)}
                        >
                          {filteredReservedChannels.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data.value}>
                                  {data.label}
                                </Option>
                              </>
                            );
                          })}
                        </Field>
                        {touched.reservedChannels && errors.reservedChannels && (
                          <div className="invalid-feedback">{errors.reservedChannels}</div>
                        )}
                      </div>
                    )}
                    {values?.type == "medialive" && (
                      <div className="form-group">
                        <label className="form-label">
                          Media Live Region <span className="required">*</span>
                        </label>
                        <Field
                          className="custom-ant-select"
                          optionFilterProp="children"
                          name="mediaLiveRegion"
                          showSearch
                          onChange={(value) => setFieldValue("mediaLiveRegion", value)}
                          component={Select}
                          disabled={values?.fileType === "static"}
                          value={values?.mediaLiveRegion}
                          defaultValue={"Select Media Region"}
                        >
                          {awsRegions.length &&
                            awsRegions.map((data, index) => {
                              return (
                                <>
                                  <Option key={index} value={data.value}>
                                    {data.label}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.mediaLiveRegion && errors.mediaLiveRegion && (
                          <div className="invalid-feedback">{errors.mediaLiveRegion}</div>
                        )}
                      </div>
                    )}
                    <div className="form-group">
                      <label className="form-label">
                        Source Region <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="region"
                        showSearch
                        onChange={(value) => setFieldValue("region", value)}
                        component={Select}
                        value={values?.region}
                        disabled={values?.fileType === "static"}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={"Select Region"}
                      >
                        {mediaLiveTemplateRegions.length &&
                          mediaLiveTemplateRegions.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data.value}>
                                  {data.label}
                                </Option>
                              </>
                            );
                          })}
                      </Field>
                      {touched.region && errors.region && <div className="invalid-feedback">{errors.region}</div>}
                    </div>

                    <div className="form-group">
                      <label className="form-label">
                        Media Live Storage <span className="required">*</span>
                      </label>
                      <Field
                        className="custom-ant-select"
                        name="mediaLiveStorageId"
                        showSearch
                        onChange={(value) => setFieldValue("mediaLiveStorageId", value)}
                        component={Select}
                        dropdownStyle={{ zIndex: 99999999 }}
                        defaultValue={"Select Media Storage"}
                      >
                        {storageDetail.length &&
                          storageDetail.map((data, index) => {
                            return (
                              <>
                                <Option key={index} value={data._id}>
                                  {data.storage_name}
                                </Option>
                              </>
                            );
                          })}
                      </Field>
                      {touched.mediaLiveStorageId && errors.mediaLiveStorageId && (
                        <div className="invalid-feedback">{errors.mediaLiveStorageId}</div>
                      )}
                    </div>
                    {["medialive", "reserved_channel"].includes(values?.type) && (
                      <div className="form-group mb-1">
                        <Field
                          component={Checkbox}
                          onChange={(e) => {
                            setFieldValue(
                              "programDateTime",
                              e.target.checked ? PROGRAM_DATE_TIME.INCLUDE : PROGRAM_DATE_TIME.EXCLUDE,
                            );
                          }}
                          value={values?.programDateTime}
                          name="programDateTime"
                          checked={values?.programDateTime === PROGRAM_DATE_TIME.INCLUDE}
                          className="me-2"
                        />
                        <label className="form-label">Time code</label>
                      </div>
                    )}

                    {values?.type === "medialive" && values?.inputType === "SRT_PULL" && (
                      <div className="form-group mb-1">
                        <Field
                          component={Checkbox}
                          onChange={(e) => {
                            setFieldValue("passwordEnabled", e.target.checked);
                          }}
                          defaultChecked={false}
                          name="passwordEnabled"
                          checked={values?.passwordEnabled}
                          className="me-2"
                        />
                        <label className="form-label">Password</label>
                      </div>
                    )}
                    <div className="form-group mb-1">
                      <Field
                        onChange={(e) => {
                          setFieldValue("isMultiAudio", e.target.checked);
                          setFieldValue("fillMultiAudioWithStream", true);
                          setFieldValue("languages", []);
                          setFieldValue("pid", []);
                          setSelectedAudioOptions([]);
                          setSelectedPids([]);
                          setMultiAudioOption("");
                        }}
                        defaultChecked={false}
                        name="isMultiAudio"
                        component={Checkbox}
                        checked={values?.isMultiAudio}
                        className="me-2"
                      />

                      <label className="form-label">Multi Audio</label>
                    </div>
                    {values?.isMultiAudio && (
                      <div className="form-group">
                        <Field
                          className="custom-ant-select"
                          name="fillMultiAudioWithStream"
                          value={values?.fillMultiAudioWithStream}
                          onChange={(value) => {
                            setFieldValue("fillMultiAudioWithStream", value);
                            if (!value) {
                              setMultiAudioOption("iso");
                            } else {
                              setMultiAudioOption("");
                            }
                          }}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          defaultValue={"Select Multi Audio Option"}
                        >
                          <Option value={false}>Audio selection</Option>
                          <Option value={true}>Audio selection during stream add</Option>
                        </Field>
                      </div>
                    )}
                    {values?.isMultiAudio && !values?.fillMultiAudioWithStream && multiAudioOption !== "" && (
                      <Field
                        name="multiAudioOption"
                        showSearch
                        optionFilterProp="children"
                        className="custom-ant-select"
                        style={{ textTransform: "capitalize" }}
                        value={multiAudioOption}
                        onChange={(value) => {
                          handleSelectChange(value);
                          setFieldValue("multiAudioOption", value);
                          setSelectedAudioOptions([]);
                          setSelectedPids([]);
                          setFieldValue("languages", []);
                          setFieldValue("pid", []);
                          setFieldValue("track", []);
                        }}
                        placeholder="Select Audio"
                        component={Select}
                      >
                        {["ISO", "PID", "TRACK"].map((option) => (
                          <Option key={option} value={option.toLowerCase()}>
                            {option}
                          </Option>
                        ))}
                      </Field>
                    )}
                    {multiAudioOption === "pid" && values?.isMultiAudio && !values?.fillMultiAudioWithStream && (
                      <div className="form-group">
                        <Field
                          name="pid"
                          className="form-control mt-3"
                          component={MultiInputField}
                          setSelectedOptions={(value) => {
                            setSelectedPids(value);
                            setFieldValue("pid", value);
                          }}
                          selectedOptions={selectedPids}
                          placeholder="Enter Pid's"
                        />
                        {touched.pid && errors.pid && <div className="invalid-feedback">{errors.pid}</div>}
                      </div>
                    )}
                    {multiAudioOption === "track" && values.isMultiAudio && !values.fillMultiAudioWithStream && (
                      <div className="form-group">
                        <Field
                          name="track"
                          className="form-control mt-3"
                          component={MultiInputField}
                          setSelectedOptions={(value) => {
                            setSelectedTracks(value);
                            setFieldValue("track", value);
                          }}
                          selectedOptions={selectedTracks}
                          placeholder="Enter Tracks"
                        />
                        {touched.track && errors.track && <div className="invalid-feedback">{errors.track}</div>}
                      </div>
                    )}
                    {multiAudioOption === "iso" && values?.isMultiAudio && !values?.fillMultiAudioWithStream && (
                      <div className="form-group">
                        <Field
                          name="languages"
                          selectedOptions={selectedAudioOptions}
                          setSelectetOptions={(value) => {
                            setSelectedAudioOptions(value);
                            setFieldValue("languages", value);
                          }}
                          intitialOptions={multiAudioOptions.map((audio) => {
                            return { label: audio?.English, value: audio["alpha3-b"] };
                          })}
                          component={MultiSelectWithRepeat}
                        />
                        {touched.languages && errors.languages && (
                          <div className="invalid-feedback">{errors.languages}</div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-12">
        {show ? (
          <RunningStreams
            setShow={handleShowRunningStreams}
            usersList={usersList}
            getRunningStreamTemplates={getRunningStreamTemplates}
            user={user}
            entityId={entityId}
            getOrgDetails={getOrgDetails}
          />
        ) : (
          <React.Fragment>
            <div className="border-block groups-block overflow-visible">
              <div className="left-block">
                <h4 className="title-sm-t">Video Template</h4>
              </div>
              <div className="template-filters">
                <div className="select-container">
                  <Select2
                    bordered={false}
                    name="templateType"
                    placeholder="Select Media Template"
                    value={selectedTemplateType}
                    className="select"
                    isClearable={true}
                    onChange={(e) => {
                      handleTemplateChange(e);
                    }}
                    options={mediaLiveTemplateOptions}
                  />
                </div>
                {entityType == ENTITY_TYPE.ORGANIZATION && (
                  <button class="btn btn-primary me-3" onClick={openModal}>
                    Add Template
                  </button>
                )}
                {user?.role === "superadmin" && (
                  <button class="btn btn-primary me-3" onClick={() => setShow(true)}>
                    {`Show Running Templates >`}
                  </button>
                )}
              </div>
            </div>
            <br />
            <div className="configuration-items-row row">
              <div className="col-md-12">
                {/* <div className="tab-block-table">
              <div className="btn-container ms-3">
                <input
                  className="form-control"
                  type="text"
                  value={search}
                  placeholder="search..."
                  onChange={(e) => handleSearch(e)}
                />
              </div>
            </div> */}
                <div className="table-resposive table-container user-management-table">
                  {load ? (
                    <div className="bg-loader-fade">
                      <Spin className="fade-loader" indicator={antIcon} />
                      <div className="loader-back-text"></div>
                    </div>
                  ) : templates?.length ? (
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Template</th>
                          <th className="text-end pe-4">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {templates?.map((data, index) => {
                          return (
                            <tr key={index}>
                              {/* <td>{data?.templateName}</td> */}
                              <td>
                                <Tooltip title={data?.templateName}>
                                  {data?.templateName
                                    ? data?.templateName.substring(0, 40) +
                                      (data?.templateName.length > 40 ? "..." : "")
                                    : ""}
                                </Tooltip>
                              </td>
                              <td>
                                <div className="table-action-block text-end pe-4">
                                  <Dropdown
                                    onClick={() => {
                                      setTemplate(data);
                                    }}
                                    className=""
                                    overlay={
                                      <Menu
                                        items={[
                                          {
                                            label: (
                                              <a
                                                onClick={() => {
                                                  EditOpen();
                                                }}
                                              >
                                                <EditOutlined />
                                                <span>Edit</span>
                                              </a>
                                            ),
                                            key: "edit",
                                          },
                                          {
                                            label: (
                                              <a
                                                onClick={() => {
                                                  delOpen();
                                                }}
                                              >
                                                <DeleteIcon />
                                                <span>Delete</span>
                                              </a>
                                            ),
                                            key: "delete",
                                          },
                                        ]}
                                      />
                                    }
                                    trigger={["click"]}
                                    overlayClassName={"tableActionBlock"}
                                    placement={"bottomRight"}
                                  >
                                    <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                      <TheeDotsIcon />
                                    </a>
                                  </Dropdown>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  ) : (
                    <div className="text-center  pt-5 pb-5">
                      <h3>No template found</h3>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <Pagination
              current={activePage}
              pageSize={20}
              onChange={handlePageChange}
              total={totalCounts}
              className="text-center mt-3"
            />
          </React.Fragment>
        )}
      </div>
    </>
  );
};

export default MediaLiveTemplate;
